import { render } from "./SummaryBox4.vue?vue&type=template&id=c519238e&scoped=true"
import script from "./SummaryBox4.vue?vue&type=script&lang=js"
export * from "./SummaryBox4.vue?vue&type=script&lang=js"

import "./SummaryBox4.vue?vue&type=style&index=0&id=c519238e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c519238e"]])

export default __exports__